// Lightweight analytics helper: pushes to GTM dataLayer and gtag (GA4).
export function trackEvent(event, params = {}) {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch (e) {
    // no-op
  }
}

export function trackPageView(path) {
  trackEvent("page_view", { page_path: path });
}
